import { Fragment } from 'react';
import { compose, concat, isEmpty } from 'lodash/fp';
import { LocalizedText } from '@mews/framework';
import { Amount } from '@mews-commander/types';
import { TextKey } from '@mews-commander/enums';
import { ConvertedCurrencyValue, TooltippedSpan } from '@mews-commander/ui';
import { Multipliers } from '../../transformProductOrders/types';
import { TooltipLabelElement, TooltipListElement, TooltipValueElement } from './styles';
import { filterMultipliers, joinCostParts } from './utils';

const CostTooltipItem = ({ multiplier, textKey }: CostTooltipItemProps) => {
    if (multiplier === 1) {
        return null;
    }
    return (
        <Fragment>
            <TooltipLabelElement>
                <LocalizedText textKey={textKey} />
            </TooltipLabelElement>
            <TooltipValueElement>{multiplier}</TooltipValueElement>
        </Fragment>
    );
};

interface CostTooltipItemProps {
    multiplier: number;
    textKey: Mews.TextKey;
}

const CostTooltip = ({ multipliers: { night, unit, person }, timeUnitKey }: CostTooltipProps) => (
    <TooltipListElement>
        <CostTooltipItem multiplier={unit} textKey={TextKey.UnitCount} />
        <CostTooltipItem multiplier={person} textKey={TextKey.PersonPlural} />
        <CostTooltipItem multiplier={night} textKey={timeUnitKey} />
    </TooltipListElement>
);

interface CostTooltipProps {
    multipliers: Multipliers;
    timeUnitKey: Mews.TextKey;
}

export const GroupCost = ({ amount, net, multipliers, timeUnitKey }: GroupCostProps) => {
    const filteredMultipliers = filterMultipliers(multipliers);
    const tooltip = isEmpty(filteredMultipliers) ? null : (
        <CostTooltip multipliers={multipliers} timeUnitKey={timeUnitKey} />
    );
    const formattedMultipliers = compose(joinCostParts, concat<number | string>(filteredMultipliers))('');

    return (
        <TooltippedSpan tooltip={tooltip}>
            {formattedMultipliers}
            <ConvertedCurrencyValue amount={amount} net={net} />
        </TooltippedSpan>
    );
};

interface GroupCostProps {
    multipliers: Multipliers;
    amount: Amount;
    net: boolean;
    timeUnitKey: Mews.TextKey;
}
